var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstSnowBoardPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 77,
    viewBox: "0 0 68 77",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.5189,
    cy: 31.875,
    rx: 2.97249,
    ry: 2.95312,
    fill: "#DDEBF6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.08602,
    cy: 47.4766,
    rx: 2.97249,
    ry: 2.95312,
    fill: "#DDEBF6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.7,
    cx: 22.0335,
    cy: 14.9785,
    rx: 2.97249,
    ry: 2.95312,
    fill: "#DDEBF6"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 52.2689,
    cy: 3.43164,
    rx: 2.97249,
    ry: 2.95312,
    fill: "#DDEBF6"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4637,
    cy: 62.4766,
    rx: 2.97249,
    ry: 2.95312,
    fill: "#DDEBF6"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.7694,
    cy: 50.4766,
    rx: 2.97249,
    ry: 2.95312,
    fill: "#DDEBF6"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.7496,
    cy: 73.4766,
    rx: 2.97249,
    ry: 2.95312,
    fill: "#DDEBF6"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.4676,
    cy: 70.3809,
    rx: 2.97249,
    ry: 2.95312,
    fill: "#DDEBF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstSnowBoardPage);
export default __webpack_public_path__ + "static/media/firstSnow-board-page.81925d5ccde9792cbedaff8044ba266f.svg";
export { ForwardRef as ReactComponent };